import Repository from './Repository';


const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/live/device`;

export default {
  /**
   * Lists all available devices of the current live session.
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  list() {
    return Repository.get(`${base}/list`);
  },

  /**
   * Lists the status of all available streamer devices of the current live session.
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  status() {
    return Repository.get(`${base}/status`);
  },


  /**
   * Starts the streaming of a streamer device in a live session.
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  startStreamer(device = '') {
    return Repository.post(`${base}/start`, {
      device,
    });
  },

  /**
   * Stops the streaming of a streamer device in a live session.
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  stopStreamer(device = '') {
    return Repository.post(`${base}/stop`, {
      device,
    });
  },

  /**
   * Applies the given preset of a camera or encoder device in a live session.
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  apply(device, preset) {
    return Repository.post(`${base}/apply`, {
      device,
      preset,
    });
  },
};
